import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Accounts from 'Icons/Accounts';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

import dashboardOrOnboarding from 'Helpers/dashboardOrOnboarding';
import { useOnboardingContext } from 'Views/Onboarding/Contexts/OnboardingContext';
import useUserContext from 'Context/UserContext';
import fr from 'facet-rest';
import paths from 'paths';
import { useSubscriptionSetupContext } from 'Views/Onboarding/Pages/SubscriptionSetup/SubscriptionSetupContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import SubscriptionPaymentAlert from './SubscriptionSetupInitial/SubscriptionPaymentAlert';

const styles = () => ({
  root: {},
});

const overrides = buildFacetDesignOverride();

const SubscriptionSetupProcessed = ({
  className,
  classes,
}) => {
  const { clientResource } = useOnboardingContext();
  const { userResource } = useUserContext();
  const { billingInformationCollection } = useSubscriptionSetupContext();
  const [billingInformationResource] = billingInformationCollection;

  const history = useHistory();
  const goToNext = () => {
    const userAuthSetupPath = userResource.withRelationship(
      fr.relationships.userAuthenticationSetup.name,
      (_) => paths.userAuthSetup,
      () => null,
    );
    history.push(userAuthSetupPath ?? dashboardOrOnboarding(clientResource));
  };

  useScrollTopOnMount();

  const GetStartedButton = () => {
    return (
      <RoundedButton
        variant={'contained'}
        color={'primary'}
        onClick={goToNext}
        disableElevation
        fullWidth
        test={'subscription-setup-get-started-button'}
      >
        {"Let's get started"}
      </RoundedButton>
    );
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SubscriptionPaymentAlert
        icon={Accounts}
        title={billingInformationResource.attr('successTitle')}
        subTitle={<MetaControl resource={billingInformationResource} attrName="successDescription" metaOverrideSet={overrides} />}
        actionComponent={<GetStartedButton />}
      />
    </Box>
  );
};

SubscriptionSetupProcessed.defaultProps = {
  className: '',
};

SubscriptionSetupProcessed.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionSetupProcessed);
